import { colors } from "healthex-common/colors";
import styled, { css } from "styled-components";
import { ErrorMessage } from "./FormHelper.styles";
import { HXCheckbox, HXTextField } from "./base.styles";
import { FlexColumn, FlexColumnDiv } from "./common.styles";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import { LittleText } from "./HXMobilePage.styles";
export const Info = styled(FlexColumnDiv) `
    gap: 4px;
`;
export const SignatureTextFieldForResearcher = styled(HXTextField) `
    align-self: stretch;
`;
export const SigningReasonContainer = styled(FlexColumnDiv) ``;
export const SigningReasonCheckboxForResearcher = styled(HXCheckbox) `
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    align-self: stretch;
    justify-content: center;

    .MuiCheckbox-root {
        padding: 0;
        margin: 0 4px 0 0;
        border-radius: 0;
    }

    .MuiFormControlLabel-label {
        margin-top: 2px;
    }
`;
export const AISigningReasonContainer = styled(FlexColumn) `
    padding: 20px 0;
    cursor: pointer;
`;
export const AISigningReasonCheckbox = styled(HXCheckbox) `
    flex: 1 0 0;

    .MuiCheckbox-root {
        margin: 0px;
        margin: 0px 12px 0px 0px;
        width: 24px;
        height: 24px;

        &:hover {
            background: transparent;
        }
    }

    &.MuiFormControlLabel-root {
        margin: 0px;

        div {
            ${(props) => props.error &&
    css `
                    color: ${colors.tulip_main};
                `}
        }
    }
`;
export const AISigningReasonText = styled(LittleText) `
    padding-left: 36px;
    color: ${colors.black_lighter};
`;
export const SigningReasonError = styled(ErrorMessage) `
    margin: ${(props) => (props.margin ? props.margin : "4px 0 0 14px")};
    font-size: ${fontSizes.LITTLE};
    letter-spacing: 0.15px;
    line-height: 100%;
`;
export const DataUserContainer = styled(FlexColumnDiv) `
    gap: 12px;
`;
export const DataUseText = styled.div `
    color: ${colors.black_main};
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    letter-spacing: 0.15px;
`;
export const DataUseTextLink = styled.a `
    color: ${colors.black_main};
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    line-height: normal;
    letter-spacing: 0.15px;
    text-decoration: underline;
    padding: 0px;
    cursor: pointer;

    &:hover {
        color: ${colors.black_main};
    }
`;
